import type { App_Users } from "@/src/gql/graphql";
import { ADMIN_USERS_CONFIG } from "@/components/admin/users/AdminUsersConfig";
import { ADMIN_USER_DETAIL_CONFIG } from "@/components/admin/users/detail/AdminUserDetailConfig";
import { getFieldValue } from "@/components/shared/UniversalCRMTable/components/SimpleTable/tableCellFieldValue";
import { defineEntity } from "../types";

// ============================================================================
// ADMIN USERS ENTITY DEFINITION
// ============================================================================
// admin_users maps to app_users — the admin User Management surface. Distinct
// from the `employees` entity (read-mostly directory): admin_users is the full
// admin CRUD + access-grant management view. Registering it here lets the admin
// user detail view use the same registry-driven detail modal as contacts.
// ============================================================================

export const adminUsersEntity = defineEntity<App_Users>({
  tableConfig: ADMIN_USERS_CONFIG as any,

  detailConfig: ADMIN_USER_DETAIL_CONFIG,

  synthesizeField(item, fieldId) {
    return getFieldValue(item as any, fieldId);
  },
});
